export function BackgroundLogin() {
  return (
    <div className="flex-none relative" style={{width: '60%'}}>
      <img
        src="assets/LoginImg.png"
        alt="Imagem do login"
        className="inset-0 h-full object-cover"
        style={{width: '100%'}}
      />
    </div>
  );
}

export function Logo() {
  return (
    <div className="flex relative w-full justify-center">
      <img
        src="assets/logo-progenie.png"
        alt="Logo Progenie"
        className=""
      />
    </div>
  );
}